import classNames from 'classnames/bind';
import styles from './TabBar.module.css';
const cx = classNames.bind(styles);



function TabBar({ listTabBar, tabActive, getTabActive,setCurrentPage }) {
    const handleChooseTab = (tabIndex,code) => {
        getTabActive(tabIndex,code)
        if(setCurrentPage){
            setCurrentPage(1)
        }
    }
    return (
        <div className={cx('tabBar-wrapper')}>
            <div id="__notification"></div>
            <div className={cx('tabBar-content')}>
                {listTabBar && listTabBar?.map((item) => (
                    <button
                        className={cx('tabBar-btn', tabActive === item.tabIndex && 'active')}
                        key={item.tabIndex}
                        onClick={() => handleChooseTab(item.tabIndex,item?.code)}
                    >
                        {item.tabName}
                    </button>
                ))}

            </div>
        </div>
    )
}

export default TabBar;